// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updateFullDebitComments = comments => ({
    comments,
    type: actions.UPDATE_TCSM_RECORD_AUDIT_FULL_DEBIT_ITEM_COMMENTS
});



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/action-creators/full-debit-comments.js